import React, { useEffect, useState } from "react";
import { Button, ControlLabel, FormControl, FormGroup, InputGroup } from "react-bootstrap";
import {createEpisodeVideo, updateEpisodeVideo, removeEpisodeVideo} from "../../../../../api/cp";
import { Event } from "../../../Comet";
import { LINK } from "../constants";

const Videos = ({ episode }) => {
    const [video, setVideo] = useState(null);
    const [isVideoAdded, setVideoAdded] = useState(false);

    useEffect(() => {
        setVideo(episode.videos[0] ?? null);
        setVideoAdded(!!episode.videos[0]);
    }, [episode.videos]);

    const handleCreateLink = async () => {
        try {
            const response = await createEpisodeVideo(episode.id, video);
            setVideo(response);
            setVideoAdded(true);
        } catch (error) {
            console.error(error);
        }
    };

    const handleUpdateLink = async () => {
        try {
            const response = await updateEpisodeVideo(video.id, video);
            setVideo(response);
        } catch (error) {
            console.error(error);
        }
    };

    const handleRemoveLink = async (id) => {
        try {
            await removeEpisodeVideo(id);
            setVideo(null);
            setVideoAdded(false);
        } catch (error) {
            console.error(error);
        }
    };

    const handleCometEpisodeUpdate = (episode) => {
        setVideo(episode.videos);
    };

    return (
        <section style={{marginTop: '12px'}}>
            <Event event="update:episode" handler={handleCometEpisodeUpdate} />
            <FormGroup>
                <ControlLabel>Видео</ControlLabel>
                <FormGroup>
                    <InputGroup>
                        <InputGroup.Addon>Добавить ссылку</InputGroup.Addon>
                        <FormControl
                            value={video?.[LINK] || ''}
                            type="text"
                            placeholder="Введите ссылку на видео"
                            required
                            onChange={(e) => setVideo({...video, [LINK]: e.target.value})}
                        />
                    </InputGroup>
                </FormGroup>
                <p style={{fontStyle: 'italic'}}>
                    * Доступные источники видео <br />
                    - <strong>Youtube</strong> прим. https://www.youtube.com/watch?v=xxxxxxxx <br />
                    - <strong>Rutube</strong> прим. https://rutube.ru/video/xxxxxxxx/ <br />
                    - <strong>VK</strong> прим. https://vk.com/video-xxxxxxxx_xxxxxxxx <br />
                </p>
                <FormGroup>
                    {isVideoAdded
                    ? <Button
                        style={{marginTop: '12px'}}
                        onClick={handleUpdateLink}
                    >
                        Редактировать
                    </Button>
                    : <Button
                        style={{marginTop: '12px'}}
                        onClick={handleCreateLink}
                    >
                        Сохранить
                    </Button>
                    }
                    {video && (
                        <Button
                            style={{margin: '12px 0 0 12px'}}
                            onClick={() => handleRemoveLink(video.id)}
                        >
                            Удалить
                        </Button>
                    )}
                </FormGroup>
            </FormGroup>
        </section>
    );
};

export default Videos;
